import React from 'react';


const TanStackRouterDevtools =
  import.meta.env.MODE === 'production'
    ? () => null // Render nothing in production
    : React.lazy(() => {
      // Lazy load in development
      return import('@tanstack/react-router-devtools').then((res) => ({
        'default': res.TanStackRouterDevtools,
      }));
    });

const TanStackQueryDevtools =
  import.meta.env.MODE === 'production'
    ? () => null // Render nothing in production
    : React.lazy(() => {
      // Lazy load in development
      return import('@tanstack/react-query-devtools').then((res) => ({
        'default': res.ReactQueryDevtools,
      }));
    });

function Devtools({ router }) {
  return (
    <React.Suspense>
      <TanStackRouterDevtools router={router} position="top-right" />
      <TanStackQueryDevtools buttonPosition="bottom-right" />
    </React.Suspense>
  );
}

Devtools.displayName = 'Devtools';
export default Devtools;
